import * as types from './upload.actionTypes';
import * as commonActionType from '@common/store/common/common.actionsType';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  // anexos: [
  //   {
  //     Id: undefined,
  //     IdOrigemSolicitacao: undefined,
  //     NomeArquivo: undefined,
  //     Caminho: undefined,
  //     TipoAnexo: {
  //       Id: undefined,
  //       Nome: undefined,
  //       Customizado: undefined,
  //       DDados: {
  //         Label: undefined,
  //         Name: undefined,
  //         Obrigatorio: undefined,
  //         Titulo: undefined,
  //         Tooltip: undefined
  //       }
  //     },
  //     Valor: undefined,
  //     isNew: undefined,
  //     isUpdate: undefined,
  //     idDelete: undefined
  //   }
  // ],
  // anexosCustomizado: [
  //   {
  //     Id: undefined,
  //     IdOrigemSolicitacao: undefined,
  //     Descricao: undefined,
  //     NomeArquivo: undefined,
  //     Caminho: undefined,
  //     TipoAnexo: {
  //       Id: undefined,
  //       Nome: undefined,
  //       Customizado: undefined,
  //       DDados: {
  //         Label: undefined,
  //         Name: undefined,
  //         Obrigatorio: undefined,
  //         Titulo: undefined,
  //         Tooltip: undefined
  //       }
  //     },
  //     Valor: undefined,
  //     isNew: undefined,
  //     isUpdate: undefined,
  //     idDelete: undefined
  //   }
  // ]
});

export default function reduce(state = initialState, action = {}) {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.SET_ANEXOS:
      return state.merge({ anexos: payload });
    case types.SET_ANEXOS_CUSTOMIZADOS:
      return state.merge({ anexosCustomizado: payload });
    case types.RESET:
      return initialState;
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
}
